import { createContext, useContext } from "react"
import { AppInitAction, AppInitAsyncActions, AppInitSyncActions } from "./actions"
import { AppInitState } from "./types"

const contextErrorMessage = 'useAppInit must be used within an AppInitProvider'

export interface AppInitContextProps extends AppInitAsyncActions, AppInitSyncActions {
  state: AppInitState
  dispatch: React.Dispatch<AppInitAction>
}

export const AppInitContext = createContext<AppInitContextProps | undefined>(undefined)

export const useAppInit = () => {
  const context = useContext(AppInitContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }
  return context
}

export const useAppInitActions = () => {
  const context = useContext(AppInitContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }

  const {
    state,
    dispatch,
    ...actions
  } = context

  return actions
}

export const useAppInitState = () => {
  const context = useContext(AppInitContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }
  return context.state
}

export const usePlateforme = () => {
  const context = useContext(AppInitContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }
  return {
    currentPlateforme: context.state.currentPlateforme,
    plateformes: context.state.plateformes,
    theme: context.state.theme
  }
}
